// extracted by mini-css-extract-plugin
module.exports = {"scrollbar":"task_scrollbar__3N_it"};